// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3H2XD","noInteraction":"EventWrapper_noInteraction__1XBf2"};